export default __webpack_public_path__ + "static/media/connections.14049738.svg";